module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-row', [_c('b-navbar-nav'), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', {
    staticClass: "page-title mb-2"
  }, [_c('b', [_vm._v("UnUsed Booking")])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "dateDropdown"
    }
  }, [_vm._v("SI Due Date:")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.next7Days,
      "id": "SiDueDateFilter",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select SI Due Date"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.SiDueDateFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "SiDueDateFilter", $$v)
      },
      expression: "Filter.SiDueDateFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "dateDropdown"
    }
  }, [_vm._v("TR Due Date:")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.next7Days,
      "id": "TrDueDateFilter",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select TR Due Date"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.TrDueDateFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "TrDueDateFilter", $$v)
      },
      expression: "Filter.TrDueDateFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "dateDropdown"
    }
  }, [_vm._v("VGM Due Date:")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.next7Days,
      "id": "VgmDueDateFilter",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select VGM Due Date"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.VgmDueDateFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "VgmDueDateFilter", $$v)
      },
      expression: "Filter.VgmDueDateFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    ref: "search",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search Assignment"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.commonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "commonFilter", $$v)
      },
      expression: "Filter.commonFilter"
    }
  }), _vm._v(" "), _c('b-input-group-append', {
    staticClass: "mr-1"
  }, [_c('b-button', {
    attrs: {
      "disabled": !_vm.Filter.commonFilter
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")])], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('b-button', {
    staticClass: "pull-right ml-1",
    class: ' pull-right mb-1' + _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": _vm.Filter.userFilter ||
        _vm.Filter.SiDueDateFilter ||
        _vm.Filter.TrDueDateFilter ||
        _vm.Filter.VgmDueDateFilter ||
        _vm.Filter.liner_bl_release_statusFilter ||
        _vm.Filter.line_inv_statusFilter ||
        _vm.Filter.commonFilter ||
        _vm.Filter.createdAtRange.startDate ||
        _vm.Filter.createdAtRange.endDate ?
        'outline-danger' :
        'outline-primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v(_vm._s(_vm.Filter.userFilter ||
    _vm.Filter.SiDueDateFilter ||
    _vm.Filter.TrDueDateFilter ||
    _vm.Filter.VgmDueDateFilter ||
    _vm.Filter.liner_bl_release_statusFilter ||
    _vm.Filter.line_inv_statusFilter ||
    _vm.Filter.commonFilter ||
    _vm.Filter.createdAtRange.startDate ||
    _vm.Filter.createdAtRange.endDate ?
    "Filter ON" :
    "Filter OFF"))]), _vm._v(" "), (_vm.ConsoleBookingList.length > 0) ? _c('b-button', {
    staticClass: "pull-right mb-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName !== 'Export As Excel',
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('checkJobPendency', 'Export As Excel')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName !== 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$sessionsStorage.get('userId')) ? _c('userBasedClient', {
    attrs: {
      "PMC_title": 'User Summary - ' + _vm.$sessionsStorage.get('employeeName'),
      "PMC_USERID": _vm.Filter.userFilter,
      "PMC_USERNAME": _vm.$sessionsStorage.get('nameUser'),
      "PMC_USERDESIG": _vm.$sessionsStorage.get('designation'),
      "PMC_BranchClientPre": _vm.$sessionsStorage.get('branchclientPre'),
      "PMC_TransportTypePre": _vm.$sessionsStorage.get('transportTypePre'),
      "PMC_UserEmpName": _vm.$sessionsStorage.get('employeeName'),
      "PMC_UserEmpCode": _vm.$sessionsStorage.get('employeeCode')
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "1"
    }
  }, [_c('h5', [(!_vm.isLoading) ? _c('small', [_vm._v(_vm._s(_vm.totalData) + " Entries")]) : _vm._e()])])], 1), _vm._v(" "), (_vm.visible) ? _c('div', [_c('b-card', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    on: {
      "update": function($event) {
        _vm.getUnUsedBookingList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.createdAtRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "createdAtRange", $$v)
      },
      expression: "Filter.createdAtRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [(_vm.activeUserPreference) ? _c('label', [_c('b', [_vm._v("Created User Filter")])]) : _vm._e(), _vm._v(" "), (_vm.activeUserPreference) ? _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "addedUserFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.userFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "userFilter", $$v)
      },
      expression: "Filter.userFilter"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "dateDropdown"
    }
  }, [_vm._v("SI Due Date:")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.next7Days,
      "id": "SiDueDateFilter",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select SI Due Date"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.SiDueDateFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "SiDueDateFilter", $$v)
      },
      expression: "Filter.SiDueDateFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "dateDropdown"
    }
  }, [_vm._v("TR Due Date:")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.next7Days,
      "id": "TrDueDateFilter",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select TR Due Date"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.TrDueDateFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "TrDueDateFilter", $$v)
      },
      expression: "Filter.TrDueDateFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "dateDropdown"
    }
  }, [_vm._v("VGM Due Date:")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.next7Days,
      "id": "VgmDueDateFilter",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select VGM Due Date"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.VgmDueDateFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "VgmDueDateFilter", $$v)
      },
      expression: "Filter.VgmDueDateFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "liner-bl-release-status"
    }
  }, [_vm._v("Liner BL Release Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.mblInvoiceStatus,
      "id": "liner_bl_release_status",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select MBL Status"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.liner_bl_release_statusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "liner_bl_release_statusFilter", $$v)
      },
      expression: "Filter.liner_bl_release_statusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "liner-bl-release-status"
    }
  }, [_vm._v("Line Invoice Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.lineInvoiceStatus,
      "id": "line_inv_status",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select Line Invoice Status"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.line_inv_statusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "line_inv_statusFilter", $$v)
      },
      expression: "Filter.line_inv_statusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 row table-wrapper-scroll-x my-custom-scrollbar"
  }, [_c('b-table', {
    staticClass: "table-background position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "fields": _vm.columnMain,
      "items": _vm.ConsoleBookingList,
      "per-page": _vm.pagination.perPage,
      "filter": _vm.filter
    },
    on: {
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage))])]
      }
    }, {
      key: "Bookingno",
      fn: function(row1) {
        return [_c('span', [_vm._v(_vm._s("Booking Type : " + row1.item.BookingType))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Booking For : " + row1.item.Bookingfor))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Booking No : " + row1.item.Bookingno))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Contract No : " + row1.item.Contractno))]), _vm._v(" "), _c('b-button', {
          staticClass: "ml-1",
          staticStyle: {
            "margin-left": "auto",
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-danger"
          },
          on: {
            "click": function($event) {
              _vm.openModal(row1.item)
            }
          }
        }, [_vm._v("\n              Update\n            ")]), _vm._v(" "), _c('UpdateCBModal', {
          ref: "updateCBModal",
          attrs: {
            "common_id": row1.item.common_id,
            "allModuleId": row1.item.allModuleId,
            "JobNo": '',
            "booking_id": row1.item.booking_id,
            "getin_due_date": row1.item.cb_getin_due_date,
            "si_submission_date": row1.item.cb_si_submission_date,
            "vgm_submission_date": row1.item.cb_vgm_submission_date,
            "tr_submission_date": row1.item.cb_tr_submission_date,
            "liner_bl_release_status": row1.item.cb_liner_bl_release_status,
            "line_inv_status": row1.item.cb_line_inv_status,
            "linerBLNumber": '',
            "blType": '',
            "frghtTermsLiner": '',
            "linerBLupload": '',
            "mbl_release_date": '',
            "mbl_date": ''
          },
          on: {
            "update": _vm.updateData
          }
        })]
      }
    }, {
      key: "Remark",
      fn: function(row2) {
        return [_c('span', [_vm._v(_vm._s("Remark : " + row2.item.Remark))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Close Remark : " + row2.item.ClosingReasontxt))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Closed By : " + row2.item.ClosedBy))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Remark : " + row2.item.Remark))])]
      }
    }, {
      key: "VoyageNo",
      fn: function(row3) {
        return [_c('span', [_vm._v(_vm._s("Voyage No : " + row3.item.VoyageNo))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Vessel Name : " + row3.item.VesselName))])]
      }
    }, {
      key: "Branch",
      fn: function(row4) {
        return [_c('span', [_vm._v(_vm._s("Branch : " + row4.item.Branch))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("POR : " + row4.item.Por))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("POL : " + row4.item.Pol))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("POD : " + row4.item.Pod))])]
      }
    }, {
      key: "ClientName",
      fn: function(row5) {
        return [_c('span', [_vm._v(_vm._s("Client Name : " + row5.item.ClientName))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Sline Name : " + row5.item.SlineName))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Agent Name : " + row5.item.AgentName))])]
      }
    }, {
      key: "CreatedBy",
      fn: function(row6) {
        return [_c('span', [_vm._v(_vm._s("Created By : " + row6.item.CreatedBy))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Created At : " + row6.item.CreatedAt))])]
      }
    }, {
      key: "UpdatedBy",
      fn: function(row6) {
        return [_c('span', [_vm._v(_vm._s("Updated By : " + row6.item.UpdatedBy))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Updated At : " + row6.item.UpdatedAt))])]
      }
    }, {
      key: "BrfNo",
      fn: function(row10) {
        return [_c('span', [_vm._v(_vm._s("Enq No : " + row10.item.EnqNo))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Brf No : " + row10.item.BrfNo))])]
      }
    }, {
      key: "ActiveStatus",
      fn: function(row10) {
        return [_c('div', {
          attrs: {
            "id": 'row' + row10.item.booking_id
          }
        }, [(
          _vm.$sessionsStorage.get('designation') == 'Admin' &&
          _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh') ? _c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row10.item.booking_id,
            "name": "approval",
            "value": row10.item.isbookingactive == 1 ? true : false
          },
          on: {
            "change": function($event) {
              _vm.activateBooking(row10.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row10.item.isbookingactive == 1 ? 'success' : 'danger'
          }
        }, [_vm._v(_vm._s(row10.item.ActiveStatus))])], 1)]) : _vm._e()], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s("Active Status : " + row10.item.ActiveStatus))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("BL Status : " + row10.item.Linerblreleasestatus))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Line Status : " + row10.item.Lineinvstatus))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("From Booing Response : " + row10.item.FromBooingResponse))])]
      }
    }, {
      key: "SiCutOff",
      fn: function(row10) {
        return [_c('span', [_vm._v(_vm._s("Si Cut Off : " + row10.item.SiCutOff))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Si Due Date : " + row10.item.SiDueDate))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Si Submission : " + row10.item.cb_si_submission_date))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Vgm Due Date : " + row10.item.VgmDueDate))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Vgm Submission : " + row10.item.cb_vgm_submission_date))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Tr Due Date : " + row10.item.TrDueDate))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Tr Submission : " + row10.item.cb_tr_submission_date))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Get In Due Date : " + row10.item.GetInDueDate))])]
      }
    }, {
      key: "ValidTill",
      fn: function(row10) {
        return [_c('span', [_vm._v(_vm._s("Valid Till : " + row10.item.ValidTill))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Validity Start : " + row10.item.ValidityStart))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Validity End : " + row10.item.ValidityEnd))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Vessel Sail Start Date : " + row10.item.VesselSaleStartDate))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Vessel Sail End Date : " + row10.item.VesselSaleEnddate))])]
      }
    }])
  }), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55ffe050","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/Pendency/unusedBooking.vue
// module id = 2647
// module chunks = 0